import React, { useEffect, Suspense } from "react";
import { Layout, message } from "antd";
import { Routes, Route, useLocation } from "react-router-dom";
import Auth from "./authentication/Auth";
import Clockify from "../components/clockify"
import Dashborad from "./Dashborad";
import PrivateRoute from "./PrivateRoute";
import SentryErrorHandler from "./shared/SentryErrorHandler";
import "../../src/assets/css/bootstrap.min.css";
import "../../src/assets/css/icons.css";
import "../../src/assets/css/app.css";
import "../../src/assets/scss/index.scss";
import Home from "./Home";
import { usePersistedStore } from "../store/persisted-store";
import { useGeneralStore } from "../store/slices/createGeneralSlice";

const { Content } = Layout;

export default function App() {
  const general = useGeneralStore();
  const { checkUserTTl, TtlUpdator, AuthLoading, auth } = usePersistedStore();
  const error = general.view.error;
  const errorTime = general.view.errorTime;
  const success = general.view.success;
  const successTime = general.view.successTime;

  let { pathname } = useLocation();

  useEffect(() => {
    let currentDate = Date.now();

    // const currentDate = Date.now();
    if (auth?.ttl !== null && currentDate >= auth?.ttl && auth?.userToken) {
      checkUserTTl(pathname)
        .then(() => {
          TtlUpdator();
          AuthLoading(false);
        })
        .catch(() => {
          AuthLoading(false);
        });
    }
  }, [pathname]);

  useEffect(() => {
    if (error) {
      message.error(error);
    }
  }, [errorTime]);

  useEffect(() => {
    if (success) {
      message.success(success);
    }
  }, [successTime]);

  return (
    <Layout className="layout">
      <SentryErrorHandler />
      <Content className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/clockify"
            element={
              <Suspense fallback={<div>...</div>}>
                {/* <PrivateRoute> */}
                <Clockify />
                {/* </PrivateRoute> */}
              </Suspense>
            } />
          <Route path="/auth/*" element={<Auth />} />
          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <Dashborad />
              </PrivateRoute>
            }
          />
        </Routes>
      </Content>
    </Layout>
  );
}
